import {
  FiGrid, FiCalendar, FiMessageSquare, FiUserPlus, FiBriefcase, FiScissors, FiPackage,
  FiPercent, FiUsers, FiAward, FiTag, FiBell, FiDollarSign, FiArrowUpRight, FiList,
  FiStar, FiImage, FiFileText, FiShield,
} from 'react-icons/fi';

// Sidebar groups; also used by the top bar to title the current page
export const navGroups = [
  {
    title: 'Overview',
    items: [{ to: '/dashboard', label: 'Dashboard', icon: FiGrid }],
  },
  {
    title: 'Operations',
    items: [
      { to: '/appointments', label: 'Appointments', icon: FiCalendar },
      { to: '/support/tickets', label: 'Support Tickets', icon: FiMessageSquare },
      { to: '/partner-leads', label: 'Partner Leads', icon: FiUserPlus },
    ],
  },
  {
    title: 'Vendors',
    items: [
      { to: '/vendors-list', label: 'Vendors', icon: FiBriefcase },
      { to: '/vendor-settings/vendor-services', label: 'Vendor Services', icon: FiScissors },
      { to: '/vendor-addons', label: 'Vendor Add-ons', icon: FiPackage },
      { to: '/vendor-settings/commission', label: 'Commission', icon: FiPercent },
    ],
  },
  {
    title: 'Customers',
    items: [
      { to: '/users', label: 'Users', icon: FiUsers },
      { to: '/memberships', label: 'Memberships', icon: FiAward },
      { to: '/coupons', label: 'Coupons', icon: FiTag },
      { to: '/notification', label: 'Notifications', icon: FiBell },
    ],
  },
  {
    title: 'Finance',
    items: [
      { to: '/wallet/finance', label: 'Finance', icon: FiDollarSign },
      { to: '/wallet/withdrawal-requests', label: 'Withdrawals', icon: FiArrowUpRight },
    ],
  },
  {
    title: 'Catalog & Content',
    items: [
      { to: '/services', label: 'Service Categories', icon: FiList },
      { to: '/amenities', label: 'Amenities', icon: FiStar },
      { to: '/content', label: 'Banner Images', icon: FiImage },
      { to: '/cancellation-policy', label: 'Cancellation Policy', icon: FiShield },
      { to: '/terms-and-conditions', label: 'Terms & Conditions', icon: FiFileText },
    ],
  },
];

export const findNavItem = (pathname) => {
  for (const group of navGroups) {
    const item = group.items.find((i) => pathname.startsWith(i.to));
    if (item) return { ...item, group: group.title };
  }
  return null;
};
